import { sproutLightTheme } from "../../../generated/compatibility";
export var navigation = sproutLightTheme.colors.navigation;
export var datePicker = sproutLightTheme.colors.datePicker;
export var ai = sproutLightTheme.colors.ai;
export var analytics = sproutLightTheme.colors.analytics;
export var listening = sproutLightTheme.colors.listening;
export var growth = sproutLightTheme.colors.growth;
export var cardControl = sproutLightTheme.colors.cardControl;
export var tags = sproutLightTheme.colors.tags;
export default sproutLightTheme;